import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import s from "./PublishCompanyConfigConfirmModal.module.css";

interface PublishCompanyConfigConfirmModalProps {
  isOpen: boolean;
  mode: "create" | "edit";
  configCode?: string;
  displayName: string;
  changeReason: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function PublishCompanyConfigConfirmModal({
  isOpen,
  mode,
  configCode,
  displayName,
  changeReason,
  isPending,
  onCancel,
  onConfirm,
}: PublishCompanyConfigConfirmModalProps) {
  const isCreate = mode === "create";
  const confirmLabel = isCreate
    ? "Create configuration"
    : "Publish new version";

  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          {isCreate ? "Create configuration?" : "Publish new version?"}
        </Heading>
        <dl className={s.summary}>
          <dt className={s.summaryLabel}>Name</dt>
          <dd className={s.summaryValue}>{displayName}</dd>
          {configCode && (
            <>
              <dt className={s.summaryLabel}>Configuration code</dt>
              <dd className={s.summaryValue}>{configCode}</dd>
            </>
          )}
          <dt className={s.summaryLabel}>Version</dt>
          <dd className={s.summaryValue}>
            {isCreate ? "Version 1" : "Next available version"}
          </dd>
          <dt className={s.summaryLabel}>Change reason</dt>
          <dd className={s.summaryValue}>{changeReason}</dd>
        </dl>
        <p className={s.warning}>
          {isCreate
            ? "Version 1 will be published immediately."
            : "This new version will be published immediately."}{" "}
          Published versions are immutable and can only be superseded or
          retired.
        </p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button
              variant="tertiary"
              onPress={onCancel}
              isDisabled={isPending}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onPress={onConfirm}
              isDisabled={isPending}
            >
              {isPending
                ? isCreate
                  ? "Creating…"
                  : "Publishing…"
                : confirmLabel}
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
